import { useAuth } from "@/context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Flame, Mail, User } from "lucide-react";
import { useTranslation } from "react-i18next";

export const BottomNav = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!user) return null;

  const homeTo = (user.is_ambassador && (user.free_eternal_candles || 0) > 0) ? "/ambassadeur" : "/";
  const items = [
    { to: homeTo, icon: Home, label: t("nav.home"), testid: "bottomnav-home" },
    { to: "/mes-bougies", icon: Flame, label: t("nav.myCandles"), testid: "bottomnav-candles" },
    { to: "/messages", icon: Mail, label: t("nav.messages"), testid: "bottomnav-messages" },
    { to: "/profil", icon: User, label: t("nav.profile"), testid: "bottomnav-profile" },
  ];

  return (
    <>
      <div aria-hidden="true" style={{ height: "calc(env(safe-area-inset-bottom) + 84px)" }} data-testid="bottom-nav-spacer" />
      <nav className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/10 bg-black" style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 12px)" }} data-testid="bottom-nav">
        <div className="mx-auto flex max-w-2xl items-stretch justify-around px-2 pt-2">
          {items.map((it) => {
            const active = (it.to === "/" || it.to === "/ambassadeur") ? pathname === it.to : pathname.startsWith(it.to);
            const Icon = it.icon;
            return (
              <button
                key={it.to}
                type="button"
                onClick={() => navigate(it.to)}
                className={`flex flex-1 flex-col items-center gap-1 py-1 transition-colors ${active ? "text-sky-400" : "text-white/75 hover:text-white"}`}
                data-testid={it.testid}
              >
                <Icon size={22} strokeWidth={active ? 2.4 : 1.8} />
                <span className="text-xs font-semibold">{it.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};
